module.exports = __webpack_public_path__ + "static/media/btn_parents_02_parentstis.a9a41e1c.png";